<template>
  <div style="height: 100%; width: 100%;" v-loading="eventTypes == null">
    <span v-if="eventTypes != null">
      <el-menu
        :default-active="'/home/attendance/'+(this.$router.currentRoute.params.eventTypeId ? this.$router.currentRoute.params.eventTypeId : this.eventTypes[0].o_id)"
        :router="true"
        mode="horizontal"
      >
        <el-menu-item
          v-for="type in this.eventTypes"
          :key="type.o_id"
          :index="'/home/attendance/'+type.o_id"
        >{{type.name}}</el-menu-item>
      </el-menu>
      <div style="margin: 16px; justify-content: center;">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </span>
  </div>
</template>


<script>
import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {};
    },
    computed: {...mapFields(["terms", "eventTypes"])},
    watch: {
        eventTypes() {
            if (!this.$router.currentRoute.params.eventTypeId) {
                this.$router.push("/home/attendance/" + this.eventTypes[0].o_id);
            }
        }
    },
    mounted() {
        if (this.terms == null) this.$store.dispatch("pullTerms");
        if (this.eventTypes == null) this.$store.dispatch("pullEventTypes");
    },
    methods: {}
};
</script>
